enum PowerBIReports {

    ProyeccionDesembolsos = "9cb141ed-2d5a-44da-be75-c9a20c081378",
    FunnelComerciales = "50a01833-411a-4345-82ff-d890f8df5ff3",
    Preaprobados = "4ab8e0ea-4be5-414f-acbf-fbddf0e8fc95",
    GroupPowerBIEmbed = "bb747530-d0ab-4382-b8bc-6090357d8454",
    InformeJunta = "5b100c52-79aa-467d-b855-be611c4e27c9",
    BaseGeneral = "686d859d-8aa9-40a4-af42-84dffd3c89ff",
    InformeDistribuidor = "85179fe8-49be-40a4-8de4-9a2f1312cfba",
    InformeComercial = "fe335189-65bc-4b3d-afdf-6a6deebb422a",
    Tiempos = "b510dd09-7171-4251-a983-21a5f817c06e",
    SaludCartera = "f6ff70d9-029e-48c7-a7e4-a8d86b5e0347"
}


interface InfoReport {

    id: string,
    name: string,
    embedUrl?: string | null,
    accessToken?: string | null,
    exp?: number | null,


}

interface IReportsByRol {
    [key: string]: InfoReport[]
}


const ReportsByRol: IReportsByRol = {
    "admin": [
        {
            id: PowerBIReports.Preaprobados,
            name: "Preaprobados",
            
        },
        {
            id: PowerBIReports.ProyeccionDesembolsos,
            name: "Proyección Desembolso",
        },
        {
            id: PowerBIReports.InformeJunta,
            name: "Informe Junta"
        },
        {
            id: PowerBIReports.InformeDistribuidor,
            name: "Distribuidor"
        },
        {
            id: PowerBIReports.FunnelComerciales,
            name: "Funnels Comercial"
        },
        {
            id: PowerBIReports.Tiempos,
            name: "Tiempos"
        },
        {
            id: PowerBIReports.SaludCartera,
            name:"Salud Cartera"
        }
    ],
    "inversionistas": [
        {
            id: PowerBIReports.InformeJunta,
            name: "Informe de Junta"
        },
        {
            id: PowerBIReports.Tiempos,
            name: "Tiempos"
        }
    ],
    "distribuidor": [
        {
            id: PowerBIReports.InformeDistribuidor,
            name: "Distribuidor"
        }
    ],
    "comercial": [
        {
            id: PowerBIReports.InformeComercial,
            name: "Comercial"
        },
        {
            id: PowerBIReports.FunnelComerciales,
            name: "Funnels Comercial"
        },
        {
            id: PowerBIReports.Tiempos,
            name: "Tiempos "
        }
    ],
}


export { PowerBIReports, InfoReport, ReportsByRol }